import React from "react";
import { Button, Input } from "antd";
import { withRouter } from "../components/withRouter";
import { openNotification } from "../functions";
import { jwtDecode } from "jwt-decode";

class Login extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isModalOpen: false,
      login: "",
      password: "",
    };

    this.customNavFunction = this.customNavFunction.bind(this);
  }

  customNavFunction() {
    let tok = jwtDecode(localStorage.getItem("ttk"));
    if (tok.role == 1 || tok.role == 99) {
      this.props.navigate("/clients");
    }

    if (tok.role == 2) {
      this.props.navigate("/saler-sales");
    }
  }

  post() {
    fetch(`https://bot.weddingchelny.ru/api/login`, {
      headers: new Headers({
        "Content-Type": "application/json; charset=utf-8",
      }),
      method: "POST",
      cache: "no-cache",
      body: JSON.stringify({
        login: this.state.login,
        password: this.state.password,
      }),
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.error) {
          openNotification("Ошибка", response.error, 1, 3.0);
        } else {
          if (response.auth) {
            localStorage.setItem("ttk", response.auth);
            this.customNavFunction();
          }
        }
      });
  }

  onChange = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    this.setState({ [name]: value });
  };

  render() {
    return (
      <div className="login_form">
        <h1>Вход</h1>
        <Input placeholder="Логин" variant="filled" name="login" onChange={this.onChange.bind(this)} />
        <Input placeholder="Пароль" variant="filled" name="password" onChange={this.onChange.bind(this)} />
        <Button
          type="primary"
          onClick={() => {
            this.post();
          }}
        >
          Войти
        </Button>
      </div>
    );
  }
}

export default withRouter(Login);
